import React, { Fragment, useState, useRef } from "react";

import Image from "./Image";
import FilmStrip from "./FilmStrip";
import Lightbox from "./Lightbox";

const DropzoneImagesHorizontal = ({
    images,
    removeSource,
    removeFile,
    type
}) => {
    const lightboxRef = useRef();

    const [currentModal, setCurrentModal] = useState(null);

    const onRemoveImage = (e, image) => {
        e.preventDefault();

        setCurrentModal(null);

        if (type === "source") {
            removeSource(image);
        }
        if (type === "file") {
            removeFile(image);
        }
    };

    return (
        <Fragment>
            {images.length ? (
                <Fragment>
                    <FilmStrip>
                        {images.map((image, index) => (
                            <Image key={index}>
                                <div
                                    style={{
                                        position: "absolute",
                                        width: "100%",
                                        height: "100%"
                                    }}
                                >
                                    <img
                                        alt={"caption"}
                                        src={image.source}
                                        style={{
                                            cursor: "pointer",
                                            width: "100%"
                                        }}
                                        onClick={() => {
                                            setCurrentModal(index);
                                            lightboxRef.current.changeIndex(
                                                index
                                            );
                                        }}
                                    />
                                    <i
                                        className="fa fa-times"
                                        style={{
                                            position: "absolute",
                                            top: "0",
                                            left: "0",
                                            fontSize: "20px",
                                            width: "20px",
                                            height: "20px",
                                            textAlign: "center",
                                            backgroundColor: "#d3d3d3"
                                        }}
                                        onClick={e =>
                                            onRemoveImage(e, image.source)
                                        }
                                    />
                                </div>
                            </Image>
                        ))}
                    </FilmStrip>
                    <Lightbox
                        images={images}
                        currentModal={currentModal}
                        ref={lightboxRef}
                    ></Lightbox>
                </Fragment>
            ) : (
                <Fragment></Fragment>
            )}
        </Fragment>
    );
};
export default DropzoneImagesHorizontal;
